/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Underline_TooltipInputs */



/**
* | output |
* | --- |
* | "Check for Events where all lines are underlined" |
*
* @param {Style_Guide_Manager_Underline_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_underline_tooltip = /** @type {((inputs?: Style_Guide_Manager_Underline_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Underline_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verifier les evenements ou toutes les lignes sont soulignees")
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfen Sie, ob alle Zeilen unterstrichen sind.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controlla gli eventi in cui tutte le righe sono sottolineate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверьте события, у которых все строки подчеркнуты.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comprobar eventos en los que todas las líneas estén subrayadas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("检查所有行都带有下划线的事件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべての行に下線が引かれているイベントをチェックする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उन घटनाओं की जाँच करें जहाँ सभी पंक्तियाँ रेखांकित हैं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Verifique os eventos em que todas as linhas estão sublinhadas.")
	return /** @type {LocalizedString} */ ("Check for Events where all lines are underlined")
});